/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1171
 */

module.exports = function (e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991
}
